<template>
  <span>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
      color="teal lighten-2"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          clearable
          v-model="innerModelStart"
          @click:clear="clearStart"
          prefix="Од"
          readonly
          v-on="on"
          hide-details
          color="teal lighten-2"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="innerModelStart"
        @input="onInputStart"
        no-title
        color="teal lighten-2"
      />
    </v-menu>
    <v-menu
      ref="menu2"
      v-model="menu2"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
      color="teal lighten-2"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          clearable
          hide-details
          v-model="innerModelEnd"
          @click:clear="clearEnd"
          prefix="До"
          readonly
          v-on="on"
          color="teal lighten-2"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="innerModelEnd"
        @input="onInput"
        :min="innerModelStart"
        no-title
        color="teal lighten-2"
      />
    </v-menu>
  </span>
</template>
<script>
export default {
  name: 'datetime-range-picker',
  data () {
    return {
      menu: false,
      menu2: false,
      innerModelStart: this.value[0],
      innerModelEnd: this.value[1],
      allowedDates: []
    }
  },
  methods: {
    clearEnd () {
      this.innerModelEnd = ''
      this.onInput()
    },
    clearStart () {
      this.innerModelStart = ''
      this.onInput()
    },
    onInput () {
      this.menu = this.menu2 = false
      this.$emit('input', [this.innerModelStart ? this.innerModelStart : '', this.innerModelEnd ? this.innerModelEnd : ''])
      if (typeof this.changeCallback === 'function') {
        this.changeCallback([this.innerModelStart ? this.innerModelStart : '', this.innerModelEnd ? this.innerModelEnd : ''])
      }
    },
    onInputStart () {
      if (this.innerModelStart > this.innerModelEnd) {
        this.innerModelEnd = ''
      }
      this.onInput()
    }
  },
  props: {
    value: {
      type: Array,
      default () {
        return ['', '']
      }
    },
    label: {
      type: String
    },
    changeCallback: {
      type: Function
    }
  }
}
</script>
